import BaseController from "sap/mcsuite/controller/BaseController";
import Subtask from "./Subtask";

export type AddCreationParams = {
    tableName?: string;
    class?: string;
    action?: string;
    initialData?: Record<string, any>;
    onSubmitEvent?: (controller: BaseController, subtaskId: string, data: any) => void;
    onBeforeSubmitEvent?: (controller: BaseController, subtaskId: string, data: any) => void;
    onAfterSubmitEvent?: (controller: BaseController, subtaskId: string, data: any) => void;
};

export default class Add extends Subtask {
    tableName: string;
    class: string;
    action: string;
    initialData: Record<string, any>;
    onSubmitEvent: (controller: BaseController, subtaskId: string, data: any) => void;
    onBeforeSubmitEvent: (controller: BaseController, subtaskId: string, data: any) => void;
    onAfterSubmitEvent: (controller: BaseController, subtaskId: string, data: any) => void;

    constructor(controller: any, subtaskId: string, params?: AddCreationParams) {
        super(controller, subtaskId);
        this.metadata.name = "Add Subtask";
        this.tableName = params?.tableName || "";
        this.class = params?.class || "";
        this.action = params?.action || "add";
        this.initialData = params?.initialData || {};
        this.onSubmitEvent = params?.onSubmitEvent ? params.onSubmitEvent : this.onSubmitDefault;
        this.onBeforeSubmitEvent = params?.onBeforeSubmitEvent ? params.onBeforeSubmitEvent : this.onBeforeSubmitDefault;
        this.onAfterSubmitEvent = params?.onAfterSubmitEvent ? params.onAfterSubmitEvent : this.onAfterSubmitDefault;
        const tableModel = this.buildTableModel();
        this.controller.getView().setModel(tableModel, 'tableName');
        this.resetModelChanges();
        const initialDataModel = this.buildInitialData();
        this.controller.getView().setModel(initialDataModel, 'newEntity');
        this.attachEvents();
    }

    buildTableModel(): sap.ui.model.json.JSONModel {
        const tableModel = new sap.ui.model.json.JSONModel();
        tableModel.setData({
            tableName: this.tableName,
            class: this.class,
            action: this.action,
        });
        return tableModel;
    }

    buildInitialData(): sap.ui.model.json.JSONModel {
        const initialDataModel = new sap.ui.model.json.JSONModel();
        initialDataModel.setData(this.initialData);
        const viewData: any = this.controller.getView().getViewData();
        if (viewData && viewData.queryParameters) {
            const queryParams = viewData.queryParameters;
            for (const key in queryParams) {
                if (!(key in this.initialData)) {
                    initialDataModel.setProperty('/' + key, queryParams[key]);
                }
            }
        }
        const queryModel = viewData && viewData.queryParameters ? viewData.queryParameters : {};
        return initialDataModel;
    }
    
    onSubmitDefault(controller: BaseController, subtaskId: string, data: any): void {
    }

    onBeforeSubmitDefault(controller: BaseController, subtaskId: string, data: any): void {
    }

    onAfterSubmitDefault(controller: BaseController, subtaskId: string, data: any): void {
    }


}
